<template lang="pug">
.devices
  //- Barra de navegación
  van-nav-bar(
    :title="$t(`devices.${account.brand}`)"
    left-arrow
    @click-left="close")

  //- Sección principal
  .main
    .padding
      img.addUnit__img(src="@/assets/img/addDevice.png")

      .addUnit__message.margin-double-top
        .addUnit__message__title {{ $t('devices.account.title') }}

      .margin-top.text--center(v-if="!account.devices.length") {{ $t('devices.noDevices') }}

      div(v-else)
        //- Fila de dispositivo
        .units__device__bar(
          v-for="(device, key) in account.devices"
          :key="key")
          .units__device__name
            van-icon(name="device")
            span
              | {{ device.name}}
              br(v-if="device.installation")
              span.units__device__label(v-if="device.installation") {{ device.installation }} > {{ device.unit }}


  //- Botón de desvincular una cuenta
  .button-bottom-group
    button.button-bottom(v-if="account.extConfigURL"  @click="openPCM(account.extConfigURL)") {{ $t('devices.nestPermission') }}
    button.button-bottom.text-danger(@click="confirmUnlinkAccount(account.brand)") {{ $t('devices.unlinkAccount') }}

</template>

<script>
import DevicesService from '@/services/devices.service';
import { getErrorId } from '@/services/error.service';
import OpenLinkMixin from '@/mixins/OpenLink.mixin';

export default {
  data() {
    return {
      isLoading: false,
    };
  },

  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  mixins: [OpenLinkMixin],
  methods: {
    /**
     * Confirma si realmente quiere desvincular el dispositivo
     */
    confirmUnlinkAccount(brand) {
      this.$dialog
        .confirm({
          title: this.$i18n.t('devices.unlinkAccountConfirm.title'),
          message: this.$i18n.t('devices.unlinkAccountConfirm.message'),
        })
        .then(() => {
          this.unlinkAccount(brand);
        });
    },

    /**
     * Desvincula el dispositivo
     */
    async unlinkAccount(brand) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;

        // Realizo la petición
        await DevicesService.unlinkAccount(brand);
        this.$toast.clear();

        // Confirmo los cambios
        this.$dialog
          .alert({
            title: this.$i18n.t('devices.unlinkAccountSuccess.title'),
            message: this.$i18n.t('devices.unlinkAccountSuccess.message'),
          })
          .then(() => {
            this.close(true);
          });
      } catch (error) {
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();

        this.$dialog
          .alert({
            title: this.$i18n.t('errors.default.title'),
            message: this.$i18n.t('errors.default.message'),
          })
          .then(() => {
            this.close();
          });
      } finally {
        this.isLoading = false;
      }
    },

    close(reload) {
      this.$emit('close', reload);
    },

    async openPCM(url) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.isLoading = true;
        this.accountError = null;

        // Realizo la petición
        // eslint-disable-next-line no-undef
        this.openLinkMixin(url, this.exitCallback);

        this.$toast.clear();
      } catch (error) {
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({
          mask: true,
          message: this.$i18n.t('general.errors.default.message'),
        });
      } finally {
        this.isLoading = false;
      }
    },

    exitCallback() {
      this.close(true);
    },
  },

  created() {
    console.log('Account', this.account);
  },
};
</script>
